module.exports = __webpack_public_path__ + "img/logo.efc0053f.png";